import { produce } from '@/globals/helpers/immer';
import { AccordionState, AccordionItemID } from './accordionStore.types';

export const accordionStateReducer = produce(
	(
		accordionStateDraft: AccordionState,
		action:
			| { type: 'open'; id: AccordionItemID }
			| { type: 'close'; id: AccordionItemID }
			| { type: 'openAll' }
			| { type: 'closeAll' },
	) => {
		switch (action.type) {
			case 'open':
				accordionStateDraft.items.set(action.id, true);
				return;

			case 'close':
				accordionStateDraft.items.set(action.id, false);
				return;

			case 'openAll':
				accordionStateDraft.defaultItemOpenedState = true;
				accordionStateDraft.items.clear();
				return;

			case 'closeAll':
				accordionStateDraft.defaultItemOpenedState = false;
				accordionStateDraft.items.clear();
				return;
		}
	},
);
